import map from 'lodash/map';
import uniq from 'lodash/uniq';

export default address => {
	return uniq(map(address.connections, 'commodity'));
};
